import {computed, inject} from '@angular/core';
import {rxResource} from '@angular/core/rxjs-interop';
import {signalStore, withComputed, withMethods, withProps} from '@ngrx/signals';
import {WorksApi} from "../../../../../core/data/works/works.api";

export const WorkStore = signalStore(
  withProps((store, partnerApi = inject(WorksApi)) => {
    return {
      _works: rxResource({
        stream: () => partnerApi.getWorks(),
      })
    };
  }),
  withComputed(({_works}) => ({
    // Exposed Data Signals
    works: computed(() => _works.value() || []),
  })),
  withMethods((store) => ({
    reload: () => {
      if (store._works.error()) {
        store._works.reload();
      }
    },
  })),
);
